import React from "react";
import { Modal, Badge } from "react-bootstrap";
import SystemLog from "../../../types/systemLog";
import { getPageName, getUiInterface } from "../../../locales/translationUtils";
import { dataHoraDeUtc } from "../../../utils";

interface ViewDetailsModalProps {
  log: SystemLog | null;
  onClose: () => void;
}

const corPorNivel: Record<string, string> = {
  ERRO: "danger",
  DEBUG: "secondary",
  SUCESSO: "success",
};

/** Mostra a mensagem completa e a exceção (stack trace) de um log do sistema. */
const ViewDetailsModal: React.FC<ViewDetailsModalProps> = ({ log, onClose }) => {
  return (
    <Modal show={!!log} onHide={onClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{getPageName("systemLog")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {log && (
          <>
            <div className="mb-2">
              <Badge bg={corPorNivel[log.nivel] ?? "secondary"}>{log.nivel}</Badge>{" "}
              <strong className="ms-2">{log.origem}</strong>
            </div>
            <div className="mb-2 text-muted">
              {dataHoraDeUtc(log.criadoEm)}
            </div>
            <div className="mb-3">
              <strong>{getUiInterface("message")}:</strong>
              <p style={{ whiteSpace: "pre-wrap" }}>{log.mensagem}</p>
            </div>
            {log.excecao && (
              <div>
                <strong>{getUiInterface("exception")}:</strong>
                <pre
                  style={{
                    whiteSpace: "pre-wrap",
                    fontSize: "12px",
                    background: "#f5f5f5",
                    border: "1px solid #d6dae4",
                    borderRadius: 6,
                    padding: "8px",
                    maxHeight: "40vh",
                    overflow: "auto",
                  }}
                >
                  {log.excecao}
                </pre>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewDetailsModal;
